import { Grid, Paper } from "@material-ui/core";
import React, { useEffect, useState } from "react";
// import CarouselSlide from "../../components/Carousel/CarouselSlide";
import CarouselMenu from "../../components/carouselMenu/CarouselMenu";
//import CarouselSlide from "../../components/Carousel/CarouselSlide";
import styles from "./ViewRestaurant.module.css";
import { useStyles } from "./classes";
import DishDetail from "./DishDetail";
import RestaurantDetails from "./RestaurantDetails";
import axios from "axios";
import { useDispatch } from "react-redux";
import { showSearch } from "../../redux/actions/search";

const ViewRestaurant = (props) => {
  const classes = useStyles();
  let dispatch = useDispatch();

  const [details, setDetails] = useState({});
  const [id, setId] = useState("");
  // const [name, setName] = useState("HARD CODED");

  useEffect(() => {
    if (props.location.pathname) {
      dispatch(showSearch());

      let arr = props.location.pathname.split("/");
      let id = arr[arr.length - 2];

      let code = arr[arr.length - 1];

      setId(id);
      get(id, code);
    }
  }, [props.location.pathname, dispatch]);

  const get = async (id, code) => {
    try {
      const data = await axios.get(`restaurant/${id}`);
      if (code === "qr") {
        const details = {
          code: "SCAN",
          description: id,
          eventType: "qr scan",
          eventName: "qrScan",
        };
        await axios.post("analytics/addEvent", details);
      }

      setDetails(data.data);
    } catch (error) {
      //setAlert
      console.log("error", error);
    }
  };

  // const handleAccordian = (state) => {
  //   setExpand(!state)
  // }

  return (
    <>
      <div className={styles.HeroContainer}>
        <h3>{details.name}</h3>
      </div>

      <div className={classes.Trending}>
        <h2 className={styles.menuTxt}>Menus</h2>
        <Grid container justify="center" alignItems="center">
          <Grid
            container
            justify="center"
            alignItems="center"
            item
            xs={1}
            sm={3}
            md={3}
            lg={6}
          >
            <Paper
              className={classes.menuWrap}
              justify="center"
              alignItems="center"
            >
              <CarouselMenu id={id} justify="center" alignItems="center" />
            </Paper>
          </Grid>
        </Grid>
      </div>

      <section>
        <div className={styles.section3}>
          <Grid container>
            {/* <Grid
              container
              item
              xs={12}
              sm={12}
              md={12}
              lg={9}
              //justify="flex-start"
              alignItems="flex-start"
            >
              <Grid container xs={12} sm={12} md={12} lg={12} alignItems='flex-start' justify='flex-end' spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={12} container justify='flex-end'>
                  <Box >
                    {" "}
                    <Button className={classes.button}  onClick={expandAccordian} >Expand All</Button>
                  </Box>
                </Grid>

                <Grid
                  container
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  alignItems="center"
                  justify="center"
                >
                  {id && <DishDetail id={id} expand={expand} expandAccordian={expandAccordian} handleAccordian ={handleAccordian} />}
                </Grid>
              </Grid>
             
            </Grid> */}

            {/*Res details */}
            <Grid
              container
              item
              xs={12}
              sm={12}
              md={12}
              lg={9}
              justify="center"
              alignItems="flex-start"
            >
              {id && <DishDetail id={id} />}
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={3}>
              {id && <RestaurantDetails id={id} name={details.name} />}
            </Grid>
          </Grid>
        </div>
      </section>
    </>
  );
};

export default ViewRestaurant;
